import { Grid } from "@mui/material";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { EnrollmentsFilter } from "services/organizationPortalClient";
import SelectAssignedBy from "./SelectAssignedBy";
import SelectEnrollmentStatus from "./SelectEnrollmentStatus";
import { setTimeToEndOfDay } from "utils/dateUtils";
import FilterDatePicker from "components/FilterDatePicker";
import SelectProfession from "components/SelectProfession";
import { CommonFilter, useIsFilterApplied } from "@knowfully/ui.common";

type EnrollmentFilterProps = {
  onChange: (filter: EnrollmentsFilter) => void;
};

export default function EnrollmentFilter({
  onChange,
}: Readonly<EnrollmentFilterProps>) {
  const [filter, setFilter] = useState({} as EnrollmentsFilter);
  const isFilterApplied = useIsFilterApplied(filter, []);
  const { formatMessage: t } = useIntl();

  const onChangeInternal = (prop: keyof EnrollmentsFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as EnrollmentsFilter);
  };

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);

  const clearFilter = () => {
    setFilter({} as EnrollmentsFilter);
  };

  return (
    <CommonFilter
      searchText={filter.searchText}
      onSearchTextChange={(val: string | undefined) => onChangeInternal("searchText", val)}
      onClear={clearFilter}
      isFilterApplied={isFilterApplied}
      searchLabel={t({ id: "searchByNameEmailTitle" })}
    >
      <Grid item xs={12} sm={12} md={4}>
        <SelectAssignedBy
          value={filter.assignedBy}
          onChange={(value) => onChangeInternal("assignedBy", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <SelectEnrollmentStatus
          value={filter.enrollmentStatusId}
          onChange={(value) => onChangeInternal("enrollmentStatusId", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <SelectProfession
          value={filter.professionIds ?? []}
          onChange={(value) => onChangeInternal("professionIds", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2}>
        <FilterDatePicker
          label={t({ id: "startDate" })}
          value={filter.enrollmentStartDate}
          onChange={(value) => onChangeInternal("enrollmentStartDate", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2}>
        <FilterDatePicker
          label={t({ id: "endDate" })}
          value={filter.enrollmentEndDate}
          onChange={(value) =>
            onChangeInternal("enrollmentEndDate", setTimeToEndOfDay(value))
          }
        />
      </Grid>
    </CommonFilter>
  );
}
